// Smallest file size for multipart that S3 accepts
export const FILE_CHUNK_SIZE_IN_BYTES = 5 * 1024 * 1024;
